import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { Popup, Footer, Body } from '@calendly/ui/components/popup'

const renderInvoiceError = () => (
  <p>{HtmlParser(I18n.t('errors.billing.invoice.try_again_html'))}</p>
)

export const UpcomingInvoiceError = ({ onClose, strategy }) => (
  <Popup
    title={strategy.upcomingInvoiceErrorI18n}
    onClose={onClose}
  >
    <Body>
      {renderInvoiceError()}
    </Body>
    <Footer>
      <Button onClick={onClose}>
        {I18n.t('publisher.action.ok')}
      </Button>
    </Footer>
  </Popup>
)
